import styled from "@emotion/styled/macro";
import { Input } from "antd";


const AddInput = styled(Input)`
  height: 44px;
  font-size: 16px;
`;

export default AddInput